import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@nextui-org/react';
import { LogIn } from 'lucide-react';

const TEAL = '#3FCED2';

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

/**
 * Hinweis-Modal für nicht eingeloggte Nutzer (Port des AuthModal-Flows
 * aus der Flutter-App): zeigt einen Login-Hinweis mit Link zur Anmeldung.
 */
const LoginPromptModal: React.FC<LoginPromptModalProps> = ({
  isOpen,
  onClose,
  message,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      classNames={{
        base: 'bg-zinc-900 border border-zinc-800 text-white',
        closeButton: 'text-gray-400 hover:bg-zinc-800',
      }}
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-2">
          <LogIn size={20} style={{ color: TEAL }} />
          Anmeldung erforderlich
        </ModalHeader>
        <ModalBody>
          <p className="text-gray-300 text-sm">
            {message ||
              'Bitte melde dich an, um im Forum mitzumachen.'}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="flat"
            className="bg-zinc-800 text-gray-300"
            onPress={onClose}
          >
            Abbrechen
          </Button>
          <Button
            style={{ backgroundColor: TEAL, color: '#000' }}
            className="font-semibold"
            onPress={() => {
              onClose();
              navigate('/login');
            }}
          >
            Zum Login
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LoginPromptModal;
